

export enum UtilCategory {
    Unknown,
    NexCity,
    NexPark,
    NexAI,
    NexComm,
    NexConnect,
    NexAnalytics,
    NexShield,
    UmojoCommon,
    Operations,
    Product,
    Tools,
    Tradeshows
}

type CategoryLookup = { text: string; value: UtilCategory | null };


export const categories: Array<CategoryLookup> = [
    { text: 'NexCity', value: UtilCategory.NexCity },
    { text: 'NexPark', value: UtilCategory.NexPark },
    { text: 'NexAI', value: UtilCategory.NexAI },
    { text: 'NexComm', value: UtilCategory.NexComm },
    { text: 'NexConnect', value: UtilCategory.NexConnect },
    { text: 'NexAnalytics', value: UtilCategory.NexAnalytics },
    { text: 'NexShield', value: UtilCategory.NexShield },
    { text: 'Umojo Common', value: UtilCategory.UmojoCommon },
    { text: 'Operations', value: UtilCategory.Operations },
    { text: 'Product', value: UtilCategory.Product },
    { text: 'Tools', value: UtilCategory.Tools },
    { text: 'Tradeshows', value: UtilCategory.Tradeshows }
];

export const DefaultCategory: CategoryLookup = { text: 'Select Category...', value: UtilCategory.Unknown };

export const getCategoryDisplayName = (categoryValue: UtilCategory | undefined | null): string => {
    const category: CategoryLookup | undefined = getCategory(categoryValue);
    return category?.text || 'N/A';
};

export const getCategory = (categoryValue: UtilCategory | undefined | null): CategoryLookup | undefined => {
    if (categoryValue === undefined || categoryValue === null) {
        return undefined;
    }
    return categories.find((cat) => cat.value === categoryValue);
};